import NavBar from "./Components/NavBar";
import Home from "./Components/Home";
import SocialLinks from "./Components/SocialLinks";
import About from "./Components/About";
import Education from "./Components/Education";
import Portfolio from "./Components/Portfolio";
import Contact from "./Components/Contact";

function App() {
  return (
    <div className="relative min-h-screen bg-gray-950 antialiased overflow-x-hidden w-full max-w-full">
      <div className="relative z-0 w-full max-w-full overflow-x-hidden">
        <NavBar />

        <section className="relative overflow-hidden">
          <Home />
        </section>

        <div className="hidden lg:block fixed left-0 top-[35%] z-[60]">
          <SocialLinks />
        </div>

        <section className="relative w-full overflow-x-hidden -mt-px">
          <About />
        </section>

        <section className="relative w-full overflow-x-hidden -mt-px">
          <Education />
        </section>

        <section className="relative w-full overflow-x-hidden -mt-px">
          <Portfolio />
        </section>

        <section className="relative w-full overflow-x-hidden -mt-px">
          <Contact />
        </section>
      </div>
    </div>
  );
}

export default App;
